export default __webpack_public_path__ + "static/media/chica-head-desktop@2x.0a21bbe4.png";